import { echartGaugeYear } from '../common';

export function echartAnellGaugeYear(vis, datos) {
  echartGaugeYear(
    'chartAnellGaugeYear',
    'no_dataAnellGaugeYear',
    datos.resultset,
    'ANELL CICLISTA: EVOLUCIÓ ANY',
  );
}
export function echartAccesosGaugeYear(vis, datos) {
  document
    .querySelector('#tabAccessosAnellCiclista')
    .addEventListener('click', () => {
      requestAnimationFrame(() => {
        echartGaugeYear(
          'chartAccessosAnellGaugeYear',
          'no_dataAcessosAnellGaugeYear',
          datos.resultset,
          'ACCESSOS ANELL CICLISTA: EVOLUCIÓ ANY',
        );
      });
    });
}
